






































































































































































































































































































































import axios from 'axios';
import Vue from 'vue';
import i18n from 'vue-i18n';
import CoFormGroup from '@/components/Molecules/co-form-group/CoFormGroup.vue';
import EventBus from '@/eventBus';
import CoCard from '@/components/Molecules/co-card/CoCard.vue';
import CoCollapsible from '@/components/Molecules/co-collapsible/CoCollapsible.vue';
import CoText from '@/components/Atoms/co-text/CoText.vue';
import CoHeadline from '@/components/Atoms/co-headline/CoHeadline.vue';
import CoEditableText from '@/components/Molecules/co-editable-text/CoEditableText.vue';
import CoLink from '@/components/Atoms/co-link/CoLink.vue';
import CoPill from '@/components/Atoms/co-pill/CoPill.vue';
import CoLabel from '@/components/Atoms/co-label/CoLabel.vue';
import CoSwitch from '@/components/Atoms/co-switch/CoSwitch.vue';

// Register localization for standalone component previews as well as the app.
Vue.use(i18n);

export default {
    name: 'AdminSettingsLegalAndCompliance',
    components: {
        CoFormGroup,
        CoCard,
        CoCollapsible,
        CoText,
        CoHeadline,
        CoEditableText,
        CoLink,
        CoLabel,
        CoSwitch,
        CoPill,
    },
    data() {
        return {
            space: null,
            loading: false,
            settingsLoading: true,
            savingSettings: false,
            imprintAndPrivacyContent: '',
            termsAndConditionsContent: '',
            accessibilityContent: '',
            purchaseCancellationPolicyContent: '',
        };
    },
    computed: {
        // Legacy policies are enabled by default; the new policy and form require opt-in.
        imprintAndPrivacyEnabled() {
            return !this.space?.ImprintAndPrivacyPolicyOff;
        },
        termsAndConditionsEnabled() {
            return !this.space?.TermsAndConditionsOff;
        },
        accessibilityEnabled() {
            return !this.space?.AccessibilityPolicyOff;
        },
        purchaseCancellationPolicyEnabled() {
            return !!this.space?.PurchaseCancellationPolicyOn;
        },
        purchaseWithdrawalFormEnabled() {
            return !!this.space?.PurchaseCancellationFormOn;
        },
    },
    watch: {
        '$route.hash': 'openLinkedSection',
    },
    async mounted() {
        this.openLinkedSection();
        // Load settings independently so agreement requests do not delay the toggles.
        this.getSpaceSettings();
        this.loading = true;
        const [imprintAndPrivacy, termsAndConditions, accessibility, purchaseCancellationPolicy] = await Promise.all([
            this.getAgreement('/admin/agreement/privacy-policy'),
            this.getAgreement('/admin/agreement/terms-and-conditions'),
            this.getAgreement('/admin/agreement/accessibility-policy'),
            this.getAgreement('/admin/agreement/purchase-cancellation-policy'),
        ]);

        // Null marks a failed load; keep that document disabled without blocking successful siblings.
        this.imprintAndPrivacyContent = imprintAndPrivacy === null ? null : imprintAndPrivacy.Content || '';
        this.termsAndConditionsContent = termsAndConditions === null ? null : termsAndConditions.Content || '';
        this.accessibilityContent = accessibility === null ? null : accessibility.Content || '';
        this.purchaseCancellationPolicyContent =
            purchaseCancellationPolicy === null ? null : purchaseCancellationPolicy.Content || '';
        this.loading = false;
    },
    methods: {
        async openLinkedSection() {
            // Reuse the collapsible's show method so links never toggle an already open section closed.
            const section = this.$refs[this.$route.hash.slice(1)];
            if (!section?.show) return;
            section.show();
            await this.$nextTick();
            section.$el.scrollIntoView({ block: 'start' });
        },
        saveAgreement(url, agreement, contentKey) {
            if (!url) {
                console.warn('No postUrl provided for LegalAgreements component');
            }
            this.loading = true;
            return axios({
                method: 'POST',
                url,
                data: agreement,
                withCredentials: true,
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => {
                    // Update the corresponding document only after its save succeeds.
                    this[contentKey] = response?.data?.Content ?? agreement.Content ?? '';

                    // Use localized feedback for agreement changes.
                    EventBus.$emit('INFO', {
                        Message: this.$t('messages.changessaved'),
                        Details: '',
                    });
                    return this[contentKey];
                })
                .catch((error) => {
                    this.loading = false;
                    const msg = {
                        Message: this.$t('errors.failedToSaveChanges'),
                        Details: '',
                    };
                    EventBus.$emit('ERROR', msg);
                    // Let the editor retain its draft instead of closing on a failed save.
                    throw error;
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        async getAgreement(url) {
            if (!url) {
                console.warn('No getUrl provided for LegalAgreements component');
                return {};
            }
            let agreement = {};
            try {
                const response = await axios({
                    method: 'GET',
                    url,
                    withCredentials: true,
                    headers: {
                        'Content-Type': 'application/json',
                    },
                });
                agreement = response?.data || {};
            } catch (error) {
                if (error?.response?.status === 404) {
                    // do nothing
                } else {
                    const msg = {
                        Message: this.$t('messages.agreementLoadFailed'),
                        Details: '',
                    };
                    EventBus.$emit('ERROR', msg);
                    return null;
                }
            }
            return agreement;
        },
        getSpaceSettings() {
            this.settingsLoading = true;
            axios
                .get('/admin/space/settings', {
                    withCredentials: true,
                    headers: {
                        'Content-Type': 'application/json',
                    },
                })
                .then((response) => {
                    if (response && response.data) {
                        this.space = this.normalizeSpaceSettings(response.data);
                    }
                })
                .catch(() => {
                    EventBus.$emit('ERROR', {
                        Message: this.$t('messages.spaceSettingsLoadFailed'),
                        Details: '',
                    });
                })
                .finally(() => {
                    this.settingsLoading = false;
                });
        },
        // Save a switch immediately and restore its previous value if the request fails.
        saveFeatureSetting(featureName, value) {
            if (!this.space || this.settingsLoading || this.savingSettings) return;
            const previousValue = this.space[featureName];
            this.$set(this.space, featureName, value);
            this.savingSettings = true;
            axios
                .put('/admin/space/settings', JSON.stringify(this.space), {
                    withCredentials: true,
                    headers: {
                        'Content-Type': 'application/json',
                    },
                })
                .then((response) => {
                    if (response && response.data) {
                        this.space = this.normalizeSpaceSettings(response.data);
                    }
                    // Update the shared feature state immediately so navigation reacts without a reload.
                    this.$store.commit('GETSPACE', {
                        ...this.$store.state.space,
                        ...this.space,
                    });
                    EventBus.$emit('INFO', {
                        Message: this.$t('messages.changessaved'),
                        Details: '',
                    });
                })
                .catch(() => {
                    this.$set(this.space, featureName, previousValue);
                    EventBus.$emit('ERROR', {
                        Message: this.$t('messages.spaceSettingsSaveFailed'),
                        Details: '',
                    });
                })
                .finally(() => {
                    this.savingSettings = false;
                });
        },
        // Normalize feature flags so the switches always work with booleans.
        normalizeSpaceSettings(spaceSettings) {
            return {
                ...spaceSettings,
                ImprintAndPrivacyPolicyOff: !!spaceSettings?.ImprintAndPrivacyPolicyOff,
                TermsAndConditionsOff: !!spaceSettings?.TermsAndConditionsOff,
                AccessibilityPolicyOff: !!spaceSettings?.AccessibilityPolicyOff,
                PurchaseCancellationPolicyOn: !!spaceSettings?.PurchaseCancellationPolicyOn,
                PurchaseCancellationFormOn: !!spaceSettings?.PurchaseCancellationFormOn,
            };
        },
    },
};
